import { useEffect, useRef, useState } from "react";
import "../../../../styles/AuditReport.css";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Calendar from "react-calendar";
import Select from "react-select";
import "antd/dist/reset.css";
import "react-calendar/dist/Calendar.css";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import {
  useFetchReportId,
  useFetchSection,
  useFetchReportSection,
  useFetchRepAns,
  useFetchReportAdmin,
  useFetchReportAction,
  useFetchRepAttachmentsID,
  useCreateAction,
} from "../../../../utils/hooks/IndReport";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import ScrollDown from "../../../../components/ScrollDown";
import { useReport } from "../../../../utils/Context/ReportContext";
import { base_url } from "../../../../utils/apiConfig";
import { Rate, message } from "antd";
import newStyled from "@emotion/styled";
import useClientAdmin from "../../../../utils/hooks/IsClientAdmin";
// import DemoAIModal from "../../../../components/modals/DemoAIModal";
import AIInsightModal from "../../../../components/modals/AIInsightModal";
import ARActions from "./ARActions";
import ARSection from "./ARSection";
import ARDetails from "./ARDetails";
import ARSummary from "./ARSummary";
import ARHeaderActions from "./ARHeaderActions";
import ARAttachments from "./ARAttachments";
import ARQuestionnaire from "./ARQuestionnaire";

const hidePrintAttachmentClientIds = [];

const OverallExperience = ({ storeIdData, primaryColor }) => {
  const [isOverallOpen, setIsOverallOpen] = useState(true);

  return (
    <div className="card">
      <div
        className="card-header"
        onClick={() => setIsOverallOpen((prev) => !prev)}
        style={{
          backgroundColor: primaryColor || undefined,
          color: primaryColor ? "#fff" : undefined,
        }}
      >
        <p className="m-0">Overall Experience</p>
        {!isOverallOpen ? <UpOutlined /> : <DownOutlined />}
      </div>
      {isOverallOpen && (
        <div
          style={{
            textAlign: "left",
            width: "100%",
            marginTop: "8px",
            fontWeight: 500,
            padding: "8px 16px",
          }}
        >
          <p className="m-0">
            How likely are you to rate the brand you audited for its
            products/services?
          </p>
          <RateWrapper>
            <StyledRate
              count={10}
              value={storeIdData?.nps_section || 0}
              disabled
            />
          </RateWrapper>
        </div>
      )}
    </div>
  );
};

const AuditReport = ({ selectedOption }) => {
  const { auditStoreId } = useParams();
  const location = useLocation();
  const fromUrl =
    location.state?.fromUrl ||
    sessionStorage.getItem(`audit-report-origin-${auditStoreId}`) ||
    new URLSearchParams(location.search).get("fromUrl") ||
    "/reportbrowser";

  const numericAuditStoreId = Number(auditStoreId);

  const { clientId } = useClientAdmin();
  const { data: storeIdData } = useFetchReportId(
    `audit_store/${numericAuditStoreId}`,
  );
  const { data: RepSecData } = useFetchReportSection(
    `audit_store/${numericAuditStoreId}/report_section`,
  );
  const { data: SecData } = useFetchSection(
    `audit_store/${numericAuditStoreId}/section`,
  );
  const { data: ansData } = useFetchRepAns(
    `audit_store/${numericAuditStoreId}/answer`,
  );
  const { data: AdminData } = useFetchReportAdmin(
    `audit_store/${numericAuditStoreId}/admin_and_non_admin_user_for_admin`,
  );
  const { data: repActionData } = useFetchReportAction(
    `audit_store/${numericAuditStoreId}/report_action`,
  );
  const { postData: postApiData } = useCreateAction();
  const {
    data: insightsData,
    getApiData: getinsightsData,
    isLoading: insightsLoading,
  } = useFetchRepAttachmentsID();

  // ==============================================  States =================================================
  const [sectionsWithAttachments, setSectionsWithAttachments] = useState([]);
  const [loading, setLoading] = useState();
  const [isPrinting, setIsPrinting] = useState(false);
  const [show, setShow] = useState(false);
  // const [showSenti, setShowSenti] = useState(false);
  const [showAIModal, setShowAIModal] = useState(false);
  const [selectedAuditStoreId, setSelectedAuditStoreId] = useState(null);
  const [formState, setFormState] = useState({
    actionPlan: "",
    selectedDate: null,
    calendarVisible: false,
    selectedPerson: null,
  });

  const { setReportData } = useReport();
  const viewref = useRef(null);
  const printRef = useRef();
  const value = storeIdData?.audit_store_percentage || 0;
  const clientInfo = storeIdData?.audit?.store?.client || {};
  const {
    primary_color: primaryColor,
    // secondary_color: secondaryColor,
    header_image_url: headerImgUrl,
    footer_image_url: footerImgUrl,
    // background_image_url: backgroundImgUrl,
    background_image_url: backgroundImgUrl,
    score_scale: colorScale,
  } = clientInfo;

  // ============================================== useEffects =================================================
  useEffect(() => {
    if (storeIdData && RepSecData && SecData && ansData) {
      setReportData({ storeIdData, RepSecData, SecData, ansData });
      setLoading(false);
    }
  }, [storeIdData, RepSecData, SecData, ansData, setReportData]);

  useEffect(() => {
    if (!SecData || SecData.length === 0) return;

    const fetchAttachments = async () => {
      const token = localStorage.getItem("authToken");
      const updatedSections = await Promise.all(
        SecData.map(async (section) => {
          try {
            const url = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_store/${numericAuditStoreId}/section/${section.id}/attachment`;
            const { data: attachments } = await axios.get(url, {
              headers: {
                Authorization: `Token ${token}`,
                "Content-Type": "application/json",
              },
            });
            return { ...section, attachments };
          } catch (err) {
            console.log(
              `Error fetching attachments for section ${section.id}:`,
              err,
            );
            return { ...section, attachments: [] };
          }
        }),
      );
      setSectionsWithAttachments(updatedSections);
    };

    fetchAttachments();
  }, [SecData, numericAuditStoreId]);

  // ============================================== Functions =================================================
  const formatDate = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      return date.toLocaleDateString();
    }
    return date;
  };

  const handleDownloadClick = (url) => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleActionPlanChange = (e) => {
    setFormState({ ...formState, actionPlan: e.target.value });
  };

  const handleDateSelection = (date) => {
    // Format in local time; toISOString() would shift the day back for
    // timezones ahead of UTC (e.g. IST picks 10 Oct → saves 9 Oct).
    const d = new Date(date);
    const formattedDate = [
      d.getFullYear(),
      String(d.getMonth() + 1).padStart(2, "0"),
      String(d.getDate()).padStart(2, "0"),
    ].join("-");
    setFormState({
      ...formState,
      selectedDate: formattedDate,
      calendarVisible: false,
    });
  };

  const toggleCalendarVisibility = () => {
    setFormState({ ...formState, calendarVisible: !formState.calendarVisible });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      action_plan: formState.actionPlan,
      target_date: formState.selectedDate,
      person: formState.selectedPerson,
    };
    postApiData(`audit_store/${numericAuditStoreId}/report_action`, payload);
    handleClose();
  };

  // const handleViewAi = async () => {
  //   try {
  //     setShowSenti(true);
  //     await getinsightsData(`sentiment_data/${numericAuditStoreId}`);
  //     viewref.current.click();
  //   } catch (error) {
  //     console.log("Error fetching AI insights:", error.message);
  //   }
  // };

  const handleViewAi = async () => {
    setSelectedAuditStoreId(numericAuditStoreId);
    setShowAIModal(true);
  };

  const closeAIModal = () => {
    setShowAIModal(false);
    setSelectedAuditStoreId(null);
  };

  const handleDownloadExcel = async () => {
    const downloadUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_store/${auditStoreId}/xlsx_report`;
    const token = localStorage.getItem("authToken");
    const hideLoading = message.loading(
      "Downloading detailed excel, please wait...",
      0,
    );
    try {
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `token ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(
          `Failed to download: ${response.status} ${response.statusText}`,
        );
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      const fileName = storeIdData?.audit?.store?.name
        ? `Excel_Report_${storeIdData?.audit?.store?.name}.xlsx`
        : "Eecel_Report.xlsx";
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      hideLoading();
      message.success("Exported Successfully");
    } catch (error) {
      console.log("Error downloading file:", error);
      // alert("Failed to download report.");
      hideLoading();
      message.error(
        "Sorry Failed to download report.!! Please try again later",
      );
    }
  };

  const handlePrintDetails = async () => {
    const originalTitle = document.title;

    if (hidePrintAttachmentClientIds.includes(clientId)) {
      setIsPrinting(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    document.title = `${storeIdData?.audit?.store?.client?.name || ""} Audit Report`;
    window.print();
    document.title = originalTitle;

    if (hidePrintAttachmentClientIds.includes(clientId)) {
      setIsPrinting(false);
    }
  };

  const secDataMap = SecData
    ? SecData.reduce((acc, s) => {
        acc[s.id] = s;
        return acc;
      }, {})
    : {};

  const sortedRepSecData = [...RepSecData].sort((a, b) => {
    const seqA = secDataMap[a.section]?.sequence || 0;
    const seqB = secDataMap[b.section]?.sequence || 0;
    return seqA - seqB;
  });

  const transformedData = sortedRepSecData.map((section, index) => {
    const maxMarks = section?.max_marks;
    const progress = Math.floor(section.marks_percentage);
    const matchingSection = secDataMap[section.section];
    const sectionName = matchingSection
      ? matchingSection.name
      : "Unknown Section";
    const sectionSequence = matchingSection
      ? matchingSection.sequence
      : index + 1;

    return {
      key: sectionSequence,
      section: sectionName,
      score: progress,
      maxMarks: maxMarks,
    };
  });

  const handleClose = () => setShow(false);
  const isReportReady = sectionsWithAttachments.length > 0;

  return (
    <>
      <div
        className="audit-report-container p-3"
        ref={printRef}
        id="print-root"
        style={{
          backgroundImage: backgroundImgUrl
            ? `url("${backgroundImgUrl}")`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <ARHeaderActions
          isReportReady={isReportReady}
          handleDownloadExcel={handleDownloadExcel}
          handlePrintDetails={handlePrintDetails}
          setShow={setShow}
          fromUrl={fromUrl}
        />

        {headerImgUrl && (
          <div
            className="page-header mb-0"
            style={{
              backgroundColor: primaryColor || undefined,
            }}
          >
            <img src={headerImgUrl} alt="Client Header" />
          </div>
        )}

        <ARDetails
          storeIdData={storeIdData}
          handleViewAi={handleViewAi}
          value={value}
          primaryColor={primaryColor}
          colorScale={colorScale}
        />

        <ARActions actionRepData={repActionData} primaryColor={primaryColor} />
        <ARSection
          data={transformedData}
          primaryColor={primaryColor}
          colorScale={colorScale}
        />
        <OverallExperience
          storeIdData={storeIdData}
          primaryColor={primaryColor}
        />
        <ARSummary
          loading={loading}
          storeIdData={storeIdData}
          primaryColor={primaryColor}
        />
        <ARAttachments
          numericAuditStoreId={numericAuditStoreId}
          handleDownloadClick={handleDownloadClick}
          primaryColor={primaryColor}
        />

        <ARQuestionnaire
          isPrinting={isPrinting}
          ansData={ansData}
          RepSecData={RepSecData}
          sectionsWithAttachments={sectionsWithAttachments}
          primaryColor={primaryColor}
          colorScale={colorScale}
        />

        {footerImgUrl && (
          <div
            className="page-footer"
            style={{
              backgroundColor: primaryColor || undefined,
            }}
          >
            <img src={footerImgUrl} alt="Client Footer" />
          </div>
        )}
        <ScrollDown />
      </div>

      {/* ==============================================  Modals ================================================= */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create a Action Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="action-textArea">
            <p>Action Plan : </p>
            <textarea
              rows="4"
              cols="50"
              value={formState.actionPlan}
              onChange={handleActionPlanChange}
            />
          </div>
          <div>
            <p className="m-0">Target Date</p>
            <div
              className="select-date-container"
              onClick={toggleCalendarVisibility}
              style={{
                border: "1px solid #ccc",
                padding: "8px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {formState.selectedDate
                ? `Selected Date: ${formatDate(
                    new Date(formState.selectedDate),
                  )}`
                : "Select a Target Date"}
            </div>

            {formState.calendarVisible && (
              <div className="calendarContainer df">
                <Calendar
                  value={formState.selectedDate}
                  onChange={handleDateSelection}
                />
              </div>
            )}
          </div>
          <div className="my-2">
            <p className="m-0">Person Responsible</p>
            <Select
              options={AdminData.map((admin) => ({
                value: admin.email,
                label: `${admin.full_name} -- ${admin.email}`,
              }))}
              placeholder="Select a person"
              value={
                formState.selectedPerson
                  ? {
                      value: formState.selectedPerson,
                      label: `${
                        AdminData.find(
                          (admin) => admin.email === formState.selectedPerson,
                        )?.full_name
                      } -- ${formState.selectedPerson}`,
                    }
                  : null
              }
              onChange={(selectedOption) => {
                setFormState({
                  ...formState,
                  selectedPerson: selectedOption?.value,
                });
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <DemoAIModal
        viewref={viewref}
        showSenti={showSenti}
        setShowSenti={setShowSenti}
        insightsData={insightsData}
        isLoading={insightsLoading}
      /> */}
      <AIInsightModal
        open={showAIModal}
        onClose={closeAIModal}
        auditStoreId={selectedAuditStoreId}
      />
    </>
  );
};

const RateWrapper = newStyled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:8px !important; 
  margin-top:8px; 
  @media (max-width: 768px) {
    justify-content: center;
    gap: 5px;
  }`;

const StyledRate = newStyled(Rate)`
  font-size: 2rem !important;
  width: 100%;
  display: flex;
  justify-content: space-between; 
  color:#007dc1 !important;
  @media (max-width: 768px) {
    font-size: 16px !important;
    justify-content: center;
    gap: 4px !important; }
   .ant-rate-star .anticon {
    color:rgb(188, 188, 188);}
   .ant-rate-star-full .anticon {
    color: #007dc1 !important; /* Change the selected star color */ }
`;

export default AuditReport;
